const RECIPIENT_EMAIL = "exportfy.world@gmail.com";

export function buildConsultationMailto(form) {
  const subject = encodeURIComponent(`New consultation request from ${form.name || "a visitor"}`);
  const bodyLines = [
    `Name: ${form.name || ""}`,
    `Email: ${form.email || ""}`,
    `Phone: ${form.phone || ""}`,
    `Company: ${form.company || ""}`,
    `Country: ${form.country || ""}`,
    `Session: ${form.session_type || ""}`,
    `Preferred date: ${form.preferred_date || ""}`,
    `Preferred time: ${form.preferred_time || ""}`,
    `Topic: ${form.topic || ""}`,
    `Notes: ${form.notes || ""}`,
  ];
  const body = encodeURIComponent(bodyLines.join("\n"));
  return `mailto:${RECIPIENT_EMAIL}?subject=${subject}&body=${body}`;
}

export function sendConsultationEmail(form) {
  if (typeof window === "undefined") return Promise.resolve(false);

  const mailto = buildConsultationMailto(form);
  window.location.href = mailto;
  return Promise.resolve(true);
}
